import React from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'

import AddDataButton from 'components/AddDataButton'
import InputSingleDataTag from 'components/InputSingleDataTag'
import { isSuperUser } from 'utils/Auth'
import Item from './Item'


const ProductTypes = props => (
  <div className="row">
    <div className="col-md-12">
      <div className="portlet light portlet-fit">
        <div className="portlet-title">
          <div className="caption">
            <span className="caption-subject sbold uppercase">Service Type list</span>
          </div>
          <div className="actions">
            <AddDataButton
              actions={props.setInputFormActive(true)}
              label="+ Add new service type"
              disabled // temporary disabled because homepage platform cannot display product type dynamically
            />
          </div>
        </div>
        <div className="portlet-body">
          <div className="table-scrollable table-scrollable-borderless">
            <table className="table table-hover table-light">
              <thead>
                <tr className="uppercase">
                  <th> # </th>
                  <th> Name </th>
                  {isSuperUser(props.user) &&
                    <th className="table-actions"> Actions </th>
                  }
                </tr>
              </thead>
              <tbody>
                {props.productTypes.rows.map((type, index) => (
                  <Item
                    key={type.id}
                    no={
                      (index + 1) +
                      ((props.productTypes.currentPage - 1) * props.productTypes.qs.limit)
                    }
                    type={type}
                    onSelectData={props.selectEditableData}
                    editableData={props.editableData}
                    onConfirmEdit={props.onConfirmEdit}
                    onChangeValueSelected={props.onChangeValueSelected}
                    user={props.user}
                  />
                ))}
              </tbody>
            </table>
          </div>
          {props.isAddingNewItem && (
            <InputSingleDataTag
              onChange={props.setInputData}
              onClickCancel={props.onClickCancel}
              value={props.inputValue}
              onClickConfirm={props.addNewItem}
              onChangeValueSelected={props.onChangeValueSelected}
            />
          )}
        </div>
        <div className="portlet-footer">
          {props.productTypes.currentPage > 1 && (
            <ReactPaginate
              previousLabel={'<'}
              nextLabel={'>'}
              breakLabel={<a href="">...</a>}
              breakClassName={'break-me'}
              pageCount={props.productTypes.totalPages}
              marginPagesDisplayed={3}
              pageRangeDisplayed={2}
              onPageChange={props.handlePageChange}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
            />
          )}
        </div>
      </div>
    </div>
  </div>
)

ProductTypes.defaultProps = {
  productTypes: {
    rows: [],
    currentPage: 1,
    totalPages: 1,
  },
  handlePageChange: () => { },
  isAddingNewItem: false,
  inputValue: '',
  user: {
    email: '',
  },
}

ProductTypes.propTypes = {
  productTypes: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.object),
    currentPage: PropTypes.number,
    totalPages: PropTypes.number,
  }),
  handlePageChange: PropTypes.func,
  isAddingNewItem: PropTypes.bool,
  setInputFormActive: PropTypes.func.isRequired,
  setInputData: PropTypes.func.isRequired,
  inputValue: PropTypes.string,
  onClickCancel: PropTypes.func.isRequired,
  addNewItem: PropTypes.func.isRequired,
  onChangeValueSelected: PropTypes.func.isRequired,
  user: PropTypes.shape({}),
}

export default ProductTypes
